<template>
  <PageContainer type="bg2">
    <div class="pay-flow ">
      <div class="">
        <div class="pay-flow__header">
          <p><i class="el-icon-s-goods" />商品清單</p>
        </div>
        <el-row class="row cart__item cart__header" style="padding-left: 32px;">
          <el-col :span="10">商品</el-col>
          <el-col :span="4">單價</el-col>
          <el-col :span="4">購物回潤金</el-col>
          <el-col :span="2">總數</el-col>
          <el-col :span="4">總計</el-col>
        </el-row>
        <div class="carts--pc" style="padding-left: 32px;">
          <el-row v-for="cart in payCarts" :key="cart.item.key" class="cart__item" type="flex" align="middle">
            <el-col :span="10" style="text-align: left;">
              <el-row type="flex" align="middle" :gutter="20">
                <el-col :span="14">
                  <ImageContainer :image-src="cart.item.imageUrl" />
                </el-col>
                <el-col :span="10">
                  <p>{{ cart.item.title }}</p>
                  <p>{{ cart.item.subtitle }}</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="4">${{ cart.item.price || 0 }}</el-col>
            <el-col :span="4">{{ cart.item.returnMoney || 0 }}</el-col>
            <el-col :span="2">{{ cart.num }}</el-col>
            <el-col :span="4">${{ (cart.item.price * cart.num) || 0 }}</el-col>
          </el-row>
        </div>
        <div class="carts--mobile">
          <el-row v-for="cart in payCarts" :key="cart.item.id" type="flex" align="middle" :gutter="20">
            <el-col :span="10">
              <ImageContainer :image-src="cart.item.imageUrl" />
            </el-col>
            <el-col :span="10">
              <div>{{ cart.item.title }}</div>
              <div>價格：${{ cart.item.price || 0 }} x {{ cart.num }}</div>
              <div>購物回潤金：{{ cart.item.returnMoney || 0 }}</div>
            </el-col>
          </el-row>
        </div>

        <el-row>
          <el-col :span="4" :offset="20" style="text-align: center;">${{ total | currency }}</el-col>
        </el-row>
      </div>
      <div>
        <div class="pay-flow__header">
          <p><i class="el-icon-document" />備註</p>
        </div>
        <div style="padding-left: 32px;">
          <el-input
            v-model="note"
            :rows="2"
            type="textarea"
            placeholder="請輸入備註"
          />
        </div>
        <div class="pay-flow__header">
          <p><i class="el-icon-s-home" />取貨方式</p>
        </div>
        <div style="padding-left: 32px;">
          <el-radio-group v-model="selectedChoose">
<!--            <el-radio label="TRADE_IN_PERSON"><p>面交</p></el-radio>-->
            <el-radio label="HOME_DELIVERY" :disabled="addresses.length === 0"><p>宅配</p></el-radio>
            <el-radio label="HOME_OTHER_DELIVERY"><p>其他地址</p></el-radio>
          </el-radio-group>
        </div>
        <el-radio-group v-if="selectedChoose === 'HOME_DELIVERY'" v-model="selectedAddress" style="padding-left: 32px;">
          <el-radio v-for="address in addresses" :key="address.id" :label="address.id">
            <div>
              <p>{{ address.receiverName }} {{ address.receiverTel }}</p>
              <p>{{ address.province }}{{ address.city }}（{{ address.postCode }}）{{ address.district }}{{ address.address }}</p>
            </div>
          </el-radio>
        </el-radio-group>
        <div v-if="selectedChoose === 'HOME_OTHER_DELIVERY'" style="padding-left: 32px;">
          <div>
            <label>收件姓名:</label>
            <el-input v-model="receiverName" style="padding:12px; width: 80%" />
          </div>
          <div>
            <label>收件電話:</label>
            <el-input v-model="receiverTel" style="padding:12px; width: 80%" />
          </div>
          <div>
            <label>收件地址:</label>
            <el-input v-model="receiverAddress" style="padding:12px; width: 80%" />
          </div>
        </div>
      </div>
      <div>
        <div class="pay-flow__header">
          <p><i class="el-icon-money" />付款方式</p>
        </div>
        <el-radio-group v-model="selectedPay" style="padding-left: 32px;">
          <el-radio label="CREDIT_CARD"><p>信用卡</p></el-radio>
          <el-radio label="UNION_PAY"><p>中國銀聯</p></el-radio>
          <el-radio label="CASH"><p>現金</p></el-radio>
        </el-radio-group>
      </div>
      <div>
        <div class="pay-flow__header">
          <p><i class="el-icon-money" />折扣方式</p>
        </div>
        <div>
          <p>購物金折扣(可用餘額:${{ currentShopMoney }})</p>
          <el-input-number v-model="shopMoney" :max="currentShopMoney" :min="0" @change="handleShopMoneyChange" />
        </div>
        <div>
          <p>購物回潤金折扣(可用餘額:${{ currentReturnMoney }})</p>
          <el-input-number v-model="returnMoney" :max="currentReturnMoney" :min="0" @change="handleReturnMoneyChange" />
        </div>
      </div>
    </div>
    <el-row type="flex" justify="end">
      <el-button type="primary" :disabled="!selectedAddress && selectedChoose === 'HOME_DELIVERY'" @click="handleCheckout">
        結帳
      </el-button>
    </el-row>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
import { mapGetters, mapActions } from 'vuex'
import ImageContainer from '@/components/ImageContainer'
import api from '@/api'

export default {
  components: {
    ImageContainer,
    PageContainer
  },
  data() {
    return {
      selectedChoose: 'HOME_DELIVERY',
      selectedAddress: '',
      selectedPay: 'CREDIT_CARD',
      shopMoney: 0,
      returnMoney: 0,
      note: '',
      receiverName: '',
      receiverTel: '',
      receiverAddress: ''
    }
  },

  computed: {
    ...mapGetters(['userInfo', 'payCarts', 'addresses', 'fromCart']),
    total() {
      const sumTotal = this.payCarts && this.payCarts.reduce((acc, cart) => acc + cart.item.price * cart.num, 0)
      if (this.shopMoney === 0 && this.returnMoney === 0) {
        return sumTotal
      } else if (this.shopMoney !== 0 && this.returnMoney === 0) {
        return sumTotal - this.shopMoney
      } else if (this.returnMoney !== 0 && this.shopMoney === 0) {
        return sumTotal - this.returnMoney
      } else {
        return sumTotal - this.shopMoney - this.returnMoney
      }
    },
    currentShopMoney() {
      return this.userInfo.profile.shopMoney
    },
    currentReturnMoney() {
      return this.userInfo.profile.returnMoney
    }
  },
  watch: {
    addresses: {
      deep: true,
      immediate: true,
      handler(value, oldValue) {
        if (value !== oldValue && value.length > 0) {
          const defaultAddress = this.addresses.find(item => item.default)
          this.selectedAddress = defaultAddress && defaultAddress.id
        }
      }
    }
  },
  methods: {
    ...mapActions(['getCarts', 'resetPayCart']),
    handleShopMoneyChange() {
      if (this.total < 0) {
        this.$message({
          type: 'error',
          message: '結帳金額不能低於0元',
          duration: 1500
        })
        this.shopMoney = 0
      }
    },
    handleReturnMoneyChange() {
      if (this.total < 0) {
        this.$message({
          type: 'error',
          message: '結帳金額不能低於0元',
          duration: 1500
        })
        this.returnMoney = 0
      }
    },
    async handleCheckout() {
      const data = {
        addressId: this.selectedAddress,
        fromCart: this.fromCart,
        paymentType: this.selectedPay,
        receiveType: this.selectedChoose,
        skuRequestList: this.payCarts.map((cart) => ({
          itemId: cart.item.id,
          num: cart.num
        })),
        shopMoneyUsed: this.shopMoney,
        returnMoneyUsed: this.returnMoney,
        note: this.note,
        addressInfo: {
          receiverName: this.receiverName,
          receiverTel: this.receiverTel,
          receiverAddress: this.receiverAddress
        }
      }
      const { success } = await api.order.postOrder(data) || {}
      if (success) {
        this.getCarts()
        this.resetPayCart()
        this.$router.push({ name: 'Order' })
        this.$message({
          type: 'success',
          message: '訂單建立成功',
          duration: 1500
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cart__item {
  text-align: center;
  margin-bottom: 10px;
}
.pay-flow {
  width: 100%;
}
.pay-flow__header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  margin-bottom: 10px;
  border-bottom: 1px solid $mainPurple;
  > p {
    font-size: 20px;
    margin: 0;
    i {
      color: $mainPurple;
      margin-right: 10px;
    }
  }
}
.el-radio {
  display: flex;
  align-items: center;
  margin: 16px 0;
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include minWidth768 {
      flex-direction: row;
      justify-content: flex-start;
    }
  }
  p {
    font-size: 16px;
    margin-bottom: 0px;

    @include minWidth768 {
      font-size: 18px;
      &:last-child {
        margin-left: 10px;
      }
      &:first-child {
        margin: 0px;
      }
    }
  }
}

::v-deep.el-radio__input.is-checked .el-radio__inner, ::v-deep.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: $mainPurple;
  background-color:  $mainPurple;
}
::v-deep.el-radio__input.is-checked+.el-radio__label, ::v-deep.el-checkbox__input.is-checked+.el-checkbox__label {
  color: $mainPurple;
}

.cart__header {
  display: none;
  @include minWidth992 {
    display: flex;
  }
}
.carts--pc {
  display: none;
  @include minWidth992 {
    display: block;
  }
}

.carts--mobile {
  font-size: 14px;
  @include minWidth992 {
    display: none;
  }
}

::v-deep.el-button--primary {
  background-color: $mainPurple;
  border: 0;
  &:hover, &:focus {
    background-color: $mainPurple;
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.7;
  }
}
</style>
